export const generateId = () => {
  return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
};

export const formatDate = (date, format = 'MM/DD/YYYY') => {
  if (!date) return '';
  
  const d = new Date(date);
  if (isNaN(d.getTime())) return '';
  
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const year = d.getFullYear();
  
  switch (format) {
    case 'YYYY-MM-DD':
      return `${year}-${month}-${day}`;
    case 'MM/DD/YYYY':
    default:
      return `${month}/${day}/${year}`;
  }
};

export const calculateDaysUntilExpiration = (iepEndDate) => {
  if (!iepEndDate) return null;
  
  const today = new Date();
  const endDate = new Date(iepEndDate);
  const timeDiff = endDate.getTime() - today.getTime();
  const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
  
  return daysDiff;
};

export const createStudent = (studentData) => {
  const now = new Date().toISOString();
  return {
    id: generateId(),
    firstName: '',
    lastName: '',
    grade: '',
    disabilityCategory: '',
    iepStartDate: '',
    iepEndDate: '',
    caseManager: '',
    parentContact: {
      name: '',
      email: '',
      phone: ''
    },
    goals: [],
    createdAt: now,
    updatedAt: now,
    ...studentData
  };
};

export const createGoal = (goalData) => {
  const now = new Date().toISOString();
  return {
    id: generateId(),
    studentId: '',
    domain: 'Academic',
    description: '',
    measurementMethod: '',
    targetCriteria: '',
    reviewFrequency: 'Monthly',
    status: 'Not Started',
    progressData: [],
    createdAt: now,
    updatedAt: now,
    ...goalData
  };
};

export const createProgressEntry = (progressData) => {
  return {
    date: formatDate(new Date(), 'YYYY-MM-DD'),
    value: 0,
    notes: '',
    dataType: 'Percentage',
    ...progressData
  };
};

export const createSettings = (settingsData) => {
  return {
    teacherName: '',
    schoolName: '',
    reminderDays: [30, 60, 90],
    defaultReviewFrequency: 'Monthly',
    dateFormat: 'MM/DD/YYYY',
    accessibility: {
      theme: 'auto',
      fontSize: 'medium',
      fontFamily: 'default',
      highContrast: false,
      reducedMotion: false,
      screenReaderOptimized: false
    },
    ...settingsData
  };
};

export const DOMAINS = [
  'Academic',
  'Behavioral', 
  'Social',
  'Communication',
  'Motor'
];

export const REVIEW_FREQUENCIES = [
  'Weekly',
  'Bi-weekly',
  'Monthly',
  'Quarterly'
];

export const GOAL_STATUSES = [
  'Not Started',
  'In Progress',
  'Mastered',
  'Discontinued'
];

export const DATA_TYPES = [
  'Percentage',
  'Frequency',
  'Rating',
  'Mastery'
];

export const DISABILITY_CATEGORIES = [
  'Specific Learning Disability',
  'Autism Spectrum Disorder',
  'Intellectual Disability',
  'Emotional Disturbance',
  'Speech or Language Impairment',
  'Visual Impairment',
  'Hearing Impairment',
  'Orthopedic Impairment',
  'Other Health Impairment',
  'Multiple Disabilities',
  'Deaf-Blindness',
  'Traumatic Brain Injury',
  'Developmental Delay'
];

export const THEMES = ['light', 'dark', 'auto'];
export const FONT_SIZES = ['small', 'medium', 'large', 'xl'];
export const FONT_FAMILIES = ['default', 'dyslexic', 'serif'];